import { releaseUtils } from '@tunein/web-utils';
import vars from 'src/common/vars';
import { isDevBuild } from '../utils/environment';

export const LOOPBACK_DOMAIN = '127.0.0.1';
const COOKIE_DOMAIN = isDevBuild() ? '' : vars.get('COOKIE_DOMAIN');

// https://en.wikipedia.org/wiki/Year_2038_problem
const permanentCookieExpiration = new Date(2038, 0, 1).getTime();
const releaseVersion = releaseUtils.calculateReleaseVersion(RELEASE_VERSION);

const localApi = '/api/v1';

const appOrigin = vars.get('GEMINI_ORIGIN');
const secureOrigin = isDevBuild()
  ? `https://${appOrigin}:3443`
  : `https://${appOrigin}`;
const insecureOrigin = isDevBuild()
  ? `http://${appOrigin}:3000`
  : `http://${appOrigin}`;

export default {
  absoluteUrlRoot: 'https://tunein.com',
  secureOrigin,
  insecureOrigin,
  api: {
    domains: {
      graphQl: vars.get('GRAPH_QL'),
      feed: vars.get('FEED_ROOT'),
      opml: vars.get('OPML_ROOT'),
      coreApi: vars.get('CORE_API'),
      reports: vars.get('REPORTS_ROOT'),
      api: vars.get('API_ROOT'),
      stream: vars.get('STREAM_ROOT'),
      radiomill: vars.get('RADIOMILL_ROOT'),
      subscriptionApi: vars.get('SUBSCRIPTION_API_ROOT'),
      local: localApi,
      loopback: `http://${LOOPBACK_DOMAIN}:${vars.get('PORT')}`,
    },
    partnerId: 'RadioTime',
    macDesktopPartnerId: '0O4y0Ibc',
    windowsDesktopPartnerId: 'gNC8hbia',
    mobileWebPartnerId: 'ze_q2*uy',
    version: releaseVersion,
  },
  cookies: {
    opts: {
      secure: vars.get('COOKIE_SECURE'),
      domain: COOKIE_DOMAIN,
    },
    permanentExpiration: permanentCookieExpiration,
    expiration: vars.get('COOKIE_EXPIRATION'),
  },
  oauth: {
    google: {
      scope:
        'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
      cookiePolicy: 'single_host_origin',
      prompt: 'select_account',
      api: 'https://apis.google.com/js/platform.js',
    },
    fb: {
      version: '3.1', // valid until 28 July 2020
      scope: 'public_profile,email,user_friends',
      language: 'en_US',
      sdk: 'https://connect.facebook.net/en_US/sdk.js',
    },
    apple: {
      // Documentation for the options below can be found here:
      // https://developer.apple.com/documentation/signinwithapplejs/incorporating_sign_in_with_apple_into_other_platforms
      scope: 'name email',
      responseMode: 'form_post',
      responseType: 'code id_token',
      messageType: 'apple.oauth.callback',
      clientId: vars.get('APPLE_CLIENT_ID'),
      authorizationUrl: 'https://appleid.apple.com/auth/authorize',
      clientUrl: `${secureOrigin}${localApi}/oauth/apple/authorize`,
      callbackUrl: `${secureOrigin}${localApi}/oauth/apple/callback`,
    },
  },
  popout: {
    path: '/popout/player/',
  },
  streamFormats: 'mp3,aac,ogg,flash,html,hls,wma',
  desktopStreamFormats: 'mp3,aac,ogg,flash,hls,wma',
  mobileStreamFormats: 'mp3,aac,ogg,hls',
  configCommands: 'ads,autoupdate,unlock,terms,location',
};
